
import { useEffect, useState, useRef } from "react";
import {
    Flex,
    Button,
    Avatar,
    Text,
    Link,
    Divider,
    useColorModeValue,
    theme,
    Box,
    Modal,
    ModalOverlay,
    ModalContent,
    Tooltip
} from "@chakra-ui/react";
import LinkedinPost from "components/tweets/masonry/linkedinPost";
import { formatTweetFromPost } from "../../../utils/linkedinUtils";
import { useOnClickOutside } from "../../../utils/helpers";
import { textStyle, variant } from "theme/names";
import moment from "moment";
import { BiHide } from "react-icons/bi";
import { AiOutlineEye } from "react-icons/ai";

export interface CommentViewProps {
    comment: any
    disableFooter?: boolean
    disableHeader?: boolean
    /** enables an icon, which opens a Modal with the original LinkedIn post */
    post?: any | null,
    isRTL?: boolean
    onClickHide?:  () => void
}

export const CommentView = ({
    disableFooter = false,
    disableHeader = false,
    comment,
    post = null,
    isRTL = false,
    onClickHide = () => { }
}: CommentViewProps) => {
    const [commentTimeDate, setCommentTimeDate] = useState<string>();
    const [avatarImageURL, setAvatarImageURL] = useState<string>();
    const bgGray100_600 = useColorModeValue(theme.colors.gray[100], theme.colors.gray[600]);
    const bgWhite_gray800 = useColorModeValue("white", "gray.800");

    useEffect(
        () => {
            const commentTime = moment(comment?.created_at).format('yy/M/D HH:SS') || "Invalid Date/Time";
            setCommentTimeDate(commentTime);

            //avatar image
            const avatarImage = "https://ez4cast.s3.eu-west-1.amazonaws.com/linkedinProfilePictures/" + comment?.profileDashEntityUrn.replace("urn:li:fsd_profile:", "") + ".jpg";
            setAvatarImageURL(avatarImage);
            // console.log(avatarImage, 'comments - avatar image')
        }, [comment]
    )
    if (!comment) return null;

    return (
        <Flex flexDirection={"column"} mb={1} borderLeft={"solid 1px " + bgGray100_600} bg={bgWhite_gray800} overflow="hidden scroll" layerStyle="bgBorderRoundedHoverShadow" textStyle="body.medium.standard">

            {!disableHeader &&
                <CommentHeader
                    name={comment?.profileFullName}
                    avatar={avatarImageURL}
                    timeDate={commentTimeDate}
                    commentURL={comment?.url}
                    post={post}
                />
            }

            <Text
                whiteSpace="pre-line"
                dir={isRTL ? "rtl" : "ltr"}
                fontFamily="'Source Sans Pro', Helvetica, sans-serif, serif"
                textStyle={textStyle["body.medium.light"]}
                // bg="red.200"
                p={1}
                pl={3}
                pr={2}

            // dangerouslySetInnerHTML={{
            //   __html: comment.comment,
            // }}
            >
                {comment.comment}
            </Text>

            {!disableFooter &&
                <CommentFooter onClickHide={onClickHide} />
            }

        </Flex>
    )
}

const CommentHeader = ({
    avatar,
    name,
    timeDate,
    commentURL,
    post
}) => {
    const [isPostOpen, setIsPostOpen] = useState(false);
    const refPost = useRef<any>();
    useOnClickOutside(refPost, async () => {
        await new Promise((resolve) => setTimeout(resolve, 200));
        setIsPostOpen(false);
    });
    const bgWhite_gray800 = useColorModeValue("white", "gray.800");
    return (
        <>
            <Flex flexDir={"row"} justifyContent={"space-between"} alignItems={"center"} p={2} >
                <Flex flexDir={"row"} justifyContent={"center"} alignItems={"center"} gap={3}>
                    <Avatar src={avatar} size="sm" name={name} />
                    <Text
                        textStyle={textStyle["body.medium.light"]} fontSize={12}
                        // color={theme.colors.gray[500]}
                        fontWeight="600" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" width="90px"
                    >
                        {name}
                    </Text>
                </Flex>
                <Box flexDirection={"row"} justifyContent={"center"} alignItems={"center"} gap={1} display={"flex"}>
                    <Link
                        variant={variant.Link.light}
                        noOfLines={1}
                        wordBreak={"break-all"}
                        maxWidth="110px"
                        fontSize={12}
                        // color={theme.colors.gray[400]}
                        mt={1}
                        mr={1}
                        href={commentURL}
                        target="_blank"
                    >
                        {timeDate}
                    </Link>
                    {post && (
                        <>
                        <Tooltip label="View the Post" hasArrow>
                            <Button
                                background="none"
                                size="xs"
                                title="View the Post"
                                onClick={() => {
                                    setIsPostOpen(true);
                                }}
                            >
                                <AiOutlineEye />
                            </Button>
                            </Tooltip>
                            {isPostOpen && (
                                <Modal
                                    isOpen={isPostOpen}
                                    onClose={() => setIsPostOpen(false)}
                                    size="2xl"
                                >
                                    <ModalOverlay />
                                    <ModalContent px="6" py="8">
                                        <LinkedinPost tweet={{ data: formatTweetFromPost(post) }} disableFooter={true}
                                            disableEditTweet={true}
                                            disableCopy={true}
                                            disableUserPopup={true}
                                            disableRequest={true}
                                            disableBookmarkButton={true}
                                            disableHideButton={true} />
                                    </ModalContent>
                                </Modal>
                            )}
                        </>
                    )}
                </Box>
            </Flex>
            <Divider mb={.5} />
        </>
    );
}

const CommentFooter = ({
    onClickHide = () => { }
}) => {

    const onClickHideHandle = () => {
        onClickHide();
    }

    return (
        <>
            <Divider mt={.5} />
            <Flex flexDir={"row"} justifyContent={"flex-end"} alignItems={"center"} p={2} >

                <Button
                    variant="secondary"
                    size={"sm"}
                    leftIcon={<BiHide />}
                    onClick={onClickHideHandle}
                >
                    Hide
                </Button>
            </Flex>
        </>
    )
}